import React from "react";
import "./Header.css";
import axios from "../api/axios";

import { Link, useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import Form from 'react-bootstrap/Form';

import SearchIcon from "@mui/icons-material/Search";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined";

import menuimg from "../assets/images/menuimg.png";
import flag from "../assets/images/flag.png";
import usa from "../assets/images/usa.png";
import singapore from "../assets/images/singapore.png";
import uae from "../assets/images/uae.png";
import logo1 from "../assets/images/logo1.png";


function Header() {
  const location = useLocation();
  const isHome = location.pathname === "/";

  const [categories, setCategories] = useState([]);
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (slug) => {
    setOpenMenus(prev => ({
      ...prev,
      [slug]: !prev[slug]
    }));
  };

  /*modal*/
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  /*for sticky header*/
  const [sticky, setSticky] = useState(false);
  const [user, setUser] = useState(null);
  const [cartCount, setCartCount] = useState(0);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [topbarText, setTopbarText] = useState("");
  const [topbarLink, setTopbarLink] = useState("#");
  const [logoUrl, setLogoUrl] = useState(logo1);
  const [customMenus, setCustomMenus] = useState([]);

  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  // Debounced search suggestions fetcher
  useEffect(() => {
    if (searchQuery.trim().length < 2) {
      setSuggestions([]);
      setShowSuggestions(false);
      return;
    }

    const delayDebounceFn = setTimeout(() => {
      axios.get(`/get-search-suggestions?query_key=${encodeURIComponent(searchQuery)}&type=product`)
        .then(res => {
          if (Array.isArray(res.data)) {
            setSuggestions(res.data);
            setShowSuggestions(true);
          }
        })
        .catch(err => {
          console.error("Error fetching search suggestions:", err);
        });
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/products?search=${encodeURIComponent(searchQuery)}`);
      setShowSuggestions(false);
      handleClose(); // Close mobile search modal if open
    }
  };

  const handleSuggestionClick = (item) => {
    if (item.type === "product" && item.slug) {
      navigate(`/product/${item.slug}`);
    } else {
      navigate(`/products?search=${encodeURIComponent(item.query)}`);
    }
    setShowSuggestions(false);
    handleClose(); // Close mobile search modal if open
  };

  useEffect(() => {
    axios.post("/business-settings", { keys: "topbar_text,topbar_banner_link,header_logo,header_menu_labels,header_menu_links" })
      .then(response => {
        if (response.data && Array.isArray(response.data)) {
          const findVal = (key) => {
            // First search for English translation/localized version
            let setting = response.data.find(s => s.type === key && s.lang === "en");
            // If not found, look for any non-empty version
            if (!setting) {
              setting = response.data.find(s => s.type === key && s.value !== null && s.value !== "");
            }
            // Fallback to the first match
            if (!setting) {
              setting = response.data.find(s => s.type === key);
            }
            return setting?.value;
          };

          const topbarTextVal = findVal("topbar_text");
          const topbarLinkVal = findVal("topbar_banner_link");
          const logoUrlVal = findVal("header_logo");
          const labelsVal = findVal("header_menu_labels");
          const linksVal = findVal("header_menu_links");

          if (topbarTextVal) {
            setTopbarText(topbarTextVal);
          }
          if (topbarLinkVal) {
            setTopbarLink(topbarLinkVal);
          }
          if (logoUrlVal) {
            setLogoUrl(logoUrlVal);
          }
          if (Array.isArray(labelsVal) && Array.isArray(linksVal)) {
            const menus = labelsVal.map((label, idx) => ({
              label,
              link: linksVal[idx] || "#"
            }));
            setCustomMenus(menus);
          }
        }
      })
      .catch(err => {
        console.error("Error fetching topbar settings in Header", err);
      });
  }, []);

  useEffect(() => {
    axios.get("/categories?all=1")
      .then(res => {
        console.log("Categories response in Header:", res.data);
        if (res.data && Array.isArray(res.data.data)) {
          setCategories(res.data.data);
        }
      })
      .catch(err => {
        console.error("Error fetching categories in Header", err);
      });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleProfileUpdate = () => {
      const userData = localStorage.getItem("user");
      if (userData) {
        try {
          setUser(JSON.parse(userData));
        } catch (e) {
          console.error("Error parsing user data in Header", e);
          setUser(null);
        }
      } else {
        setUser(null);
      }
    };

    handleProfileUpdate();
    window.addEventListener("user-profile-updated", handleProfileUpdate);
    return () => {
      window.removeEventListener("user-profile-updated", handleProfileUpdate);
    };
  }, []);

  useEffect(() => {
    const fetchCounters = () => {
      const token = localStorage.getItem("access_token");
      if (token) {
        axios.get("/profile/counters")
          .then(response => {
            if (response.data) {
              setCartCount(response.data.cart_item_count || 0);
              setWishlistCount(response.data.wishlist_item_count || 0);
            }
          })
          .catch(err => {
            console.error("Error fetching counters in Header", err);
          });
      } else {
        setCartCount(0);
        setWishlistCount(0);
      }
    };

    fetchCounters();

    window.addEventListener("cart-updated", fetchCounters);
    window.addEventListener("wishlist-updated", fetchCounters);
    window.addEventListener("user-profile-updated", fetchCounters);

    return () => {
      window.removeEventListener("cart-updated", fetchCounters);
      window.removeEventListener("wishlist-updated", fetchCounters);
      window.removeEventListener("user-profile-updated", fetchCounters);
    };
  }, []);

  const parentCategories = categories.filter(c => c.parent_id === 0 || c.parent_id === "0" || c.parent_id === null || c.parent_id === undefined);
  const getSubcategories = (parentId) => categories.filter(c => c.parent_id !== null && c.parent_id !== undefined && String(c.parent_id) === String(parentId));

  return (
    <>
      <header
        className={`
          header
          ${isHome ? "light" : "dark"}
          ${sticky ? "sticky_header" : ""}
        `}
      >
        <div className="main-header-outer">
          <div className="top-sale-alert-outer">
            <div className="container-fluid">
              <div className="top-sale-alert text-center" role="alert">
                <a href={topbarLink || "#"}>
                  {topbarText || "Free Shipping & Returns | Get 10% off on selected items"}
                </a>
              </div>
            </div>
          </div>

          <nav className="navbar navbar-expand-lg header-navbar">
            <div className="container-fluid">
              <div className="col-lg-5 col-md-5 col-sm-4 col-4">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="">
                    <MenuOutlinedIcon />
                  </span>
                </button>
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent"
                >
                  <button
                    className="mobile-close-btn"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                  >
                    ✕
                  </button>
                  <ul className="navbar-nav">
                    <li className="nav-item  d-lg-none d-md-none d-sm-block">
                      <Link to="/">Home</Link>
                    </li>



                    {parentCategories.map(parentCat => {
                      const subCats = getSubcategories(parentCat.id);
                      const isMega = parentCat.slug === "carpets-rugs";
                      const isOpen = !!openMenus[parentCat.slug];

                      if (isMega) {
                        return (
                          <li className="mega-parent nav-item cr-dropdown-dekstop" key={parentCat.id}>
                            <div
                              className="mobile-dropdown-title"
                              onClick={() => toggleMenu(parentCat.slug)}
                            >
                              <span>{parentCat.name}</span>
                              <KeyboardArrowDownIcon
                                className={`down_icon ${isOpen ? "rotate" : ""}`}
                              />
                            </div>

                            {/* DROPDOWN */}
                            <div
                              className={`mobile-dropdown-menu ${isOpen ? "active" : ""}`}
                            >
                              <div className="mega-menu">
                                {/* COLUMN 1 */}
                                <div className="mega-column">
                                  <h3>Shop By Size</h3>
                                  <div className="size-grid">
                                    <div className="inner_size">
                                      <h4>Standard Rugs:</h4>
                                      <ul>
                                        <li className="space-top">Small</li>
                                        <li><Link to="/products">2' X 3'</Link></li>
                                        <li><Link to="/products">2.5' X 4'</Link></li>
                                        <li><Link to="/products">3' X 5'</Link></li>
                                        <li className="space-top">Medium</li>
                                        <li><Link to="/products">4' X 6'</Link></li>
                                        <li><Link to="/products">5' X 7'</Link></li>
                                        <li><Link to="/products">6' X 9'</Link></li>
                                        <li className="space-top">Oversized</li>
                                        <li><Link to="/products">10' X 14'</Link></li>
                                        <li><Link to="/products">12' X 15'</Link></li>
                                        <li><Link to="/products">12' X 18'</Link></li>
                                        <li className="space-top">Large</li>
                                        <li><Link to="/products">8' X 10'</Link></li>
                                        <li><Link to="/products">9' X 12'</Link></li>
                                      </ul>
                                    </div>
                                    <div className="inner_size">
                                      <h4>Runners Rugs:</h4>
                                      <ul>
                                        <li><Link to="/products">2' X 6'</Link></li>
                                        <li><Link to="/products">2.5' X 8'</Link></li>
                                        <li><Link to="/products">2.5' X 10'</Link></li>
                                        <li><Link to="/products">2.5' X 12'</Link></li>
                                        <li><Link to="/products">2.5' X 15'</Link></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                {/* COLUMN 2 */}
                                <div className="mega-column">
                                  <h3>Shop By Style</h3>
                                  <ul>
                                    <li><Link to="/products">Modern</Link></li>
                                    <li><Link to="/products">Transitional</Link></li>
                                    <li><Link to="/products">Traditional</Link></li>
                                  </ul>
                                  <h3 className="mt-40">Shop By Material</h3>
                                  <ul>
                                    <li><Link to="/products">Wool</Link></li>
                                    <li><Link to="/products">Silk</Link></li>
                                    <li><Link to="/products">Wool & Silk</Link></li>
                                  </ul>
                                </div>

                                {/* COLUMN 3 IMAGE */}
                                <div className="mega-image">
                                  <img src={menuimg} alt="Mega Menu" />
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      }

                      if (subCats.length > 0) {
                        return (
                          <li className="nav-item drop_menu_parent" key={parentCat.id}>
                            <div
                              className="mobile-dropdown-title"
                              onClick={() => toggleMenu(parentCat.slug)}
                            >
                              <Link to={`/products?category=${parentCat.slug}`} style={{ color: 'inherit', textDecoration: 'none' }}>
                                {parentCat.name}
                              </Link>
                              <KeyboardArrowDownIcon
                                className={`down_icon ${isOpen ? "rotate" : ""}`}
                              />
                            </div>

                            <div
                              className={`short_menu ${isOpen ? "active" : ""}`}
                            >
                              <div className="drop_menu">
                                <ul>
                                  {subCats.map(sub => (
                                    <li key={sub.id}>
                                      <Link to={`/products?category=${sub.slug}`}>{sub.name}</Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            </div>
                          </li>
                        );
                      }

                      // Simple link if no subcategories
                      return (
                        <li className="nav-item" key={parentCat.id}>
                          <Link to={`/products?category=${parentCat.slug}`}>{parentCat.name}</Link>
                        </li>
                      );
                    })}

                    <li className="nav-item">
                      <Link to="/sale">Sale</Link>
                    </li>

                    {customMenus.map((menu, index) => {
                      const isExternal = menu.link.startsWith("http://") || menu.link.startsWith("https://");
                      return (
                        <li className="nav-item" key={index}>
                          {isExternal ? (
                            <a href={menu.link} target="_blank" rel="noopener noreferrer">
                              {menu.label}
                            </a>
                          ) : (
                            <Link to={menu.link}>{menu.label}</Link>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div className="col-lg-2 col-sm-4 col-4">
                <div className="logo">
                  <Link to="/">
                  <img src={logoUrl} alt="" />
                  </Link>
                </div>
              </div>

              <div className="col-lg-5 col-sm-4 col-4">
                <div className="header-user-right">
                  <div className="search-container position-relative flex-grow-1" style={{ flexGrow: 1 }}>
                    <form className="search_form" role="search" onSubmit={handleSearchSubmit}>
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search products..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onFocus={() => setShowSuggestions(true)}
                        onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                        aria-label="Search"
                      />
                      <button className="" type="submit">
                        <SearchIcon />
                      </button>
                    </form>
                    {/* Suggestions Dropdown for Desktop */}
                    {showSuggestions && suggestions.length > 0 && (
                      <div className="search-suggestions-dropdown" style={{
                        position: 'absolute',
                        top: '100%',
                        left: '0',
                        right: '0',
                        backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                        zIndex: 1000,
                        marginTop: '5px',
                        maxHeight: '350px',
                        overflowY: 'auto',
                        padding: '10px 0'
                      }}>
                        {suggestions.map((item, idx) => (
                          <div 
                            key={idx} 
                            className="suggestion-item d-flex align-items-center px-3 py-2" 
                            style={{ cursor: 'pointer', borderBottom: '1px solid rgba(0, 0, 0, 0.05)' }}
                            onClick={() => handleSuggestionClick(item)}
                          >
                            {item.type === "product" && item.thumbnail_image && (
                              <img 
                                src={item.thumbnail_image} 
                                alt={item.query} 
                                style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px', marginRight: '12px' }}
                              />
                            )}
                            <div className="text-start" style={{ flexGrow: 1 }}>
                              <div className="fw-semibold text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.2', textAlign: 'left' }}>{item.query}</div>
                              <span className="badge bg-secondary" style={{ fontSize: '0.7rem', marginTop: '4px' }}>{item.type_string}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="header-right-icons">
                    <SearchIcon className="search_icon" onClick={handleShow} />
                    <Link to="/cart" className="position-relative me-3">
                      <LocalMallOutlinedIcon className="cart_icon" />
                      {cartCount > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px', padding: '3px 6px' }}>
                          {cartCount}
                        </span>
                      )}
                    </Link>
                    <Link to={user ? "/dashboard" : "/login"} className="header-user-link me-3">
                      <PersonOutlinedIcon className="user_icon" />
                      {user && <span className="header-username d-none d-md-inline ms-1" style={{ color: 'inherit' }}>{user.name}</span>}
                    </Link>
                    <Link to="/wishlist" className="wishlist_icon_a position-relative">
                      <FavoriteBorderIcon className="wishlist_icon" />
                      {wishlistCount > 0 && (
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '10px', padding: '3px 6px' }}>
                          {wishlistCount}
                        </span>
                      )}
                    </Link>
                  </div>

                  <div class="dropdown flag-dropdown">
                    <button
                      class="dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <img src={flag} alt="Hero" />
                    </button>
                    <ul class="dropdown-menu">
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={flag} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                         
                          <img src={usa} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={singapore} alt="Hero" />
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" href="#">
                          <img src={uae} alt="Hero" />
                        </a>
                      </li>
                    </ul>

                     </div>

                </div>
              </div>
            </div>
          </nav>
        </div>

        <Modal show={show} onHide={handleClose} className="mobile_search_model">
          <Modal.Header closeButton>
            <h1>Search</h1>
          </Modal.Header>
          <Modal.Body>
            <div className="search-container position-relative w-100">
              <form className="search_form" role="search" onSubmit={handleSearchSubmit}>
                <input
                  className="form-control"
                  type="search"
                  placeholder="Search products..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                  aria-label="Search"
                />
                <button className="" type="submit">
                  <SearchIcon />
                </button>
              </form>
              {/* Suggestions Dropdown for Mobile */}
              {showSuggestions && suggestions.length > 0 && (
                <div className="search-suggestions-dropdown" style={{
                  position: 'absolute',
                  top: '100%',
                  left: '0',
                  right: '0',
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(0, 0, 0, 0.1)',
                  borderRadius: '8px',
                  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
                  zIndex: 1000,
                  marginTop: '5px',
                  maxHeight: '250px',
                  overflowY: 'auto',
                  padding: '10px 0'
                }}>
                  {suggestions.map((item, idx) => (
                    <div 
                      key={idx} 
                      className="suggestion-item d-flex align-items-center px-3 py-2" 
                      style={{ cursor: 'pointer', borderBottom: '1px solid rgba(0, 0, 0, 0.05)' }}
                      onClick={() => handleSuggestionClick(item)}
                    >
                      {item.type === "product" && item.thumbnail_image && (
                        <img 
                          src={item.thumbnail_image} 
                          alt={item.query} 
                          style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '4px', marginRight: '12px' }}
                        />
                      )}
                      <div className="text-start" style={{ flexGrow: 1 }}>
                        <div className="fw-semibold text-dark" style={{ fontSize: '0.9rem', lineHeight: '1.2', textAlign: 'left' }}>{item.query}</div>
                        <span className="badge bg-secondary" style={{ fontSize: '0.7rem', marginTop: '4px' }}>{item.type_string}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
}

export default Header;
